import Vue from 'vue';
import Router from 'vue-router';

import Dashboard from '../pages/Dashboard2.vue';
import Social from '../pages/Social.vue';
import Media from '../pages/Media.vue';
import Snackbar from '../pages/Snackbar.vue';
import Chart from '../pages/Chart.vue';
import Mailbox from '../pages/Mailbox.vue';
import Calendar from '../pages/Calendar.vue';
import Login from '../pages/core/Login.vue';
import Error from '../pages/core/Error.vue';
import Product from '../pages/product.vue';
import Customer from '../pages/customer.vue';
import Order from '../pages/order.vue';
import AddCustomer from '../pages/add_customer.vue';
import EditCustomer from '../pages/add_customer.vue';
import CreditList from '../pages/credit_list.vue';
import CreditList2 from '../pages/credit_list2.vue';
import AddProduct from '../pages/add_product.vue';
import EditProduct from '../pages/add_product.vue';
import weeklymenu from '../pages/set_weekly_menu.vue';
import maporder from '../pages/maporder.vue';
import maporder1 from '../pages/maporder1.vue';
import addon_menu from '../pages/addon_menu.vue';
import pickinglist from '../pages/pickinglist.vue';
import  add_order from '../pages/add_order.vue';
import customer_log from '../pages/customer_log.vue';
import branchorder from '../pages/branchorder.vue';
import customer_log_details from '../pages/customer_log_details.vue';
import add_branchorder from '../pages/add_branchorder.vue';
import edit_branchorder from '../pages/edit_branchorder.vue';
import view_branchorder from '../pages/view_branchorder.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        breadcrumb: [
          { name: 'dashboard' }
        ],
        title: 'Plantiful-Dashboard'
      }
    },
    {
      path: '/branchorder',
      name: 'branchorder',
      component: branchorder,
      meta: {
        breadcrumb: [
          { name: 'branchorder' }
        ],
        title: 'Plantiful-'
      }
    },
    {
      path: '/add_branchorder',
      name: 'add_branchorder',
      component: add_branchorder,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'branchorder' , href: 'branchorder' },
          { name: 'Add New Order ' }
        ],
        title: 'Plantiful-branchorder'
      }
    },
    {
      path: '/view_branchorder',
      name: 'view_branchorder',
      component: view_branchorder,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'branchorder' , href: 'branchorder' },
          { name: 'view Order ' }
        ],
        title: 'Plantiful-branchorder'
      }
    },    
    {
      path: '/edit_branchorder',
      name: 'edit_branchorder',
      component: edit_branchorder,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'branchorder' , href: 'branchorder' },
          { name: 'edit Order ' }
        ],
        title: 'Plantiful-branchorder'
      }
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Product' }
        ],
        title: 'Plantiful-Product'
      }
    },
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' }
        ],
        title: 'Plantiful-Customer'
      }
    },
    {
      path: '/customer_log',
      name: 'Customer_log',
      component: customer_log,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer_log' }
        ],
        title: 'Plantiful-Customer_log'
      }
    },
    {
      path: '/addcustomer',
      name: 'addcustomer',
      component: AddCustomer,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' , href: 'Customer' },
          { name: 'Add New' }
        ],
        title: 'Plantiful-Add customer'
      }
    },
    {
      path: '/weeklymenu',
      name: 'weeklymenu',
      component: weeklymenu,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Weekly Menu' , href: 'weeklymenu' },
        ],
        title: 'Plantiful-Weekly menu'
      }
    },
    {
      path: '/addon_menu',
      name: 'addon_menu',
      component: addon_menu,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Addon Menu' , href: 'addon_menu' },
        ],
        title: 'Plantiful-Addon menu'
      }
    },
    {
      path: '/pickinglist',
      name: 'pickinglist',
      component: pickinglist,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Picking List' , href: 'pickinglist' },
        ],
        title: 'Plantiful-Weekly menu'
      }
    },
    {
      path: '/maporder',
      name: 'maporder',
      component: maporder,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Map Order' , href: 'maporder' },
        ],
        title: 'Plantiful-Weekly menu'
      }
    },    
    {
      path: '/maporder1',
      name: 'maporder1',
      component: maporder1,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Map Order' , href: 'maporder' },
        ],
        title: 'Plantiful-Weekly menu'
      }
    },   
    {
      path: '/editcustomer',
      name: 'editcustomer',
      component: EditCustomer,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' , href: 'Customer' },
          { name: 'Edit' }
        ],
        title: 'Plantiful-Edit customer'
      }
    },
    {
      path: '/addproduct',
      name: 'addproduct',
      component: AddProduct,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'product' , href: 'Product' },
          { name: 'Add New' }
        ],
        title: 'Plantiful-Add product'
      }
    },
    {
      path: '/editproduct',
      name: 'editv',
      component: EditProduct,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'product' , href: 'Product' },
          { name: 'Edit' }
        ],
        title: 'Plantiful-Edit product'
      }
    },    
    {
      path: '/creditlist',
      name: 'creditlist',
      component: CreditList,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' , href: 'Customer' },
          { name: 'Credit List & Order History ' }
        ],
        title: 'Plantiful-Customer'
      }
    },
    {
      path: '/customer_log_details',
      name: 'customer_log_details',
      component: customer_log_details,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer log' , href: 'Customer_log' },
          { name: 'Customer log details' }
        ],
        title: 'Plantiful-Customer'
      }
    },
    {
      path: '/creditlist2',
      name: 'creditlist2',
      component: CreditList2,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' , href: 'Customer' },
          { name: 'Credit List' }
        ],
        title: 'Plantiful-Customer'
      }
    },   
    {
      path: '/add_order',
      name: 'add_order',
      component: add_order,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Customer' , href: 'Customer' },
          { name: 'Add New Order ' }
        ],
        title: 'Plantiful-Customer'
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'Order' }
        ],
        title: 'Plantiful-Order'
      }
    },
    {
      path: '/mailbox',
      name: 'Mailbox',
      component: Mailbox,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'mailbox' }
        ]
      }
    },
    {
      path: '/snackbar',
      name: 'Snackbar',
      component: Snackbar,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'snackbar' }
        ]
      }
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'calendar' }
        ]
      }
    },
    {
      path: '/social',
      name: 'Social',
      component: Social,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'social' }
        ]
      }
    },
    {
      path: '/media',
      name: 'Media',
      component: Media,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'media' }
        ]
      }
    },
    {
      path: '/chart',
      name: 'Chart',
      component: Chart,
      meta: {
        breadcrumb: [
          { name: 'dashboard', href: 'Dashboard' },
          { name: 'charts' }
        ]
      }
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {
        allowAnonymous: true
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js